export const MAP_STYLES = {
    'streets': { title: 'Streets', uri: 'mapbox://styles/mapbox/streets-v11' },
    'satellite': { title: 'Satellite', uri: 'mapbox://styles/mapbox/satellite-streets-v11' },
    'darkMode': { title: 'DarkMode', uri: 'mapbox://styles/mapbox/dark-v10' }
};
